import { TableField } from "@/types/table-field";

const id: TableField = {
  key: "Id",
  tdClass: "d-none",
  thClass: "d-none",
  sortable: false,
};
const nome: TableField = {
  key: "Nome",
  label: "Nome",
  tdClass: "align-middle",
  thClass: "align-center",
  sortable: true,
};
const tipo: TableField = {
  key: "Tipo",
  label: "Tipo",
  tdClass: "align-middle",
  thClass: "align-center",
  sortable: true,
};
const acoes: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  sortable: true,
};

export const fieldsAnexos: TableField[] = [id, nome, tipo, acoes];
